import { NoData, useDocumentTitleContext } from '@finbeat/react-toolkit';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';
import OrderInfoData from './OrderInfoData';

const OrderChangePage = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { setPageTitle } = useDocumentTitleContext();

    useEffect(() => {
        id && setPageTitle(`${t('BackOfficeOrder')} [${id}]`);
    }, [id]);

    return (
        <Card className="workplace">
            <CardBody className={`workplace__body`}>
                {id === undefined ? <NoData /> : <OrderInfoData id={id} />}
            </CardBody>
        </Card>
    );
};

export default OrderChangePage;
